import type { CustomUserClaimValue } from '@okta/okta-auth-js'
import { create } from 'zustand'
import type { UserInfo } from './types'

interface UserState {
  userInfo: UserInfo | null
  setUserInfo: (userInfo: UserInfo | null) => void
  firstName: () => CustomUserClaimValue | undefined
  isOnshore: boolean
  setIsOnshore: (isOnshore: boolean) => void
}

export const useUserStore = create<UserState>((set, get) => ({
  userInfo: null,
  setUserInfo: (userInfo: UserInfo | null) => set({ userInfo }),
  firstName: () => get().userInfo?.given_name,
  isOnshore: false,
  setIsOnshore: (isOnshore: boolean) => set({ isOnshore }),
}))
